module.exports = __webpack_public_path__ + "img/Wonder-Women-1110x450.6da82dd3.png";